import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICON_TYPE } from '@spartacus/storefront';

@Component({
  selector: 'app-gg-navigation-dropdown',
  templateUrl: './navigation-dropdown.component.html',
  standalone: false,
})
export class GgNavigationDropdownComponent {
  @Input() isOpen: boolean = false;
  @Input() controlsId: string = '';
  @Input() label: string = '';
  @Output() triggerClick = new EventEmitter<MouseEvent>();

  iconTypes = ICON_TYPE;

  handleClick(event: MouseEvent) {
    this.triggerClick.emit(event);
  }
}
